export const Error404 = () => (
    <div>
        <h1>404 Error</h1>
        <p>The page is not found.</p>
    </div>
)